import styled from "styled-components";

export const TableUser = styled.div`
    .bigBoxTableUsers{
        width: auto;
        padding: 10px 15px;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        table{
            width: 100%;
            border: none;
            border-collapse: collapse;
            background-color: #ffffff;

        tr{
            text-align: left;
            height: 35px;

            th{
                color: #403f4c;
                font-size: 12px;
                font-weight: bold;
            }

            :nth-child(2){
                border-top: 1px solid #B2B2B7;
            }
        }

        td {
            position: relative;
            border-bottom: 1px solid #B2B2B7;
            height: 33px;
            font-size: 14px;
            color: #403f4c;
            font-weight: 400;
            font-family: "Work Sans", sans-serif;
            padding: 4px 0;

            .activo{
                color: #0ED572;
                font-weight: bold;
            }
            .inativo{
                color: #FF5666;
                font-weight: bold;
            }
            button{
                background-color: transparent;
                border: 1px solid #B2B2B7;
                border-radius: 26px;
                color: #87868F;
                font-size: 11px;
                width: 58px;
                height: 22px;
                float: right;
                cursor: pointer;
            }

        }
    }
    }
`;

export const User = styled.div`
    .containerUsers {
        width: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        padding: 10px 15px;
        border-radius: 10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    }

    .userName{
        h2{
            font-size: 24px;
            font-weight: 500;
            color: #87868F;
            margin:25px 0 0 199px;
            font-family: 'Quicksand', sans-serif;
        }
    }

    .avatarRound {
        border-radius: 50%;
        object-fit: cover;
    }


    .viewUser{
        display: flex;
        width: 100%;
        flex-direction: row;
    }

    .MuiInput-underline-15:before {
        border-bottom: none;
    }

    .MuiInput-underline-15:hover:not(.MuiInput-disabled-14):not(.MuiInput-focused-13):not(.MuiInput-error-16):before {
        border-bottom: none;
    }

    /** changePhoto**/
    .changePhoto{
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 40px 60px 0 25px;

        h2{
            color: #403F4C;
            font-size: 14px;
            margin: 0 0 10px 0;
        }

        .photo{
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .fileUpload {
            position: relative;
            overflow: hidden;
            margin: 10px;
            border-radius: 26px;
            border: 1px solid #787780;
            width: 93px;
            height: 20px;
            text-align: center;
            font-size: 11px;
            font-weight: 500;
            opacity: 0.7;
            display: flex;
            align-items: center;
            justify-content: center;

            span{
                align-items: center;
                display: flex;
            }

            input.upload {
                position: absolute;
                top: 0;
                right: 0;
                margin: 0;
                padding: 0;
                font-size: 20px;
                cursor: pointer;
                opacity: 0;
                filter: alpha(opacity=0);
            }
        }

        span{
            img{
                padding: 0 5px 0 0;
            }
        }
    }

    .wrapperBlock {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0;
        border-bottom: 3px solid #d5d5d9;
    }

    .wrapperConfigButtons {
        margin-top: 25px;
        border-top: 3px solid #d5d5d9;

        >div {
            padding-top: 20px;
        }
            
        width: 100%;
        display: flex;
        gap: 25px;
    }

    .textBlock {
        color: #5778FB;
        font-size: 24px;
        font-weight: 700;
        line-height: 30px;
        padding-bottom: 12px;
    }

    /** Form **/
    .formulario{
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-top: 35px;

        label{
            color: #403F4C;
            font-size: 14px;
            font-weight: bold;
        }

        .addEmail{
            display: flex;

            input{
                width: 460px;
            }
        }

        .label{
            margin: 0 0 -15px 0;
        }

        span{
            color: #87868F;
            font-size: 10px;
            margin-left: 5px;
        }

        span.invalid {
            font-size: 10px;
            margin-left: 5px;
            color: red;
        }

        select{
            width: 220px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 15px;
            color: #403F4C;
            font-family: 'Quicksand',sans-serif;
            font-size: 14px;
            margin-top: 2px;
        }

        .selectClass{
            pointer-events: none;
            touch-action: none;


            .classToolId{
                pointer-events: all;
                touch-action: unset;
                margin-top: 10px;
            }

            select, input{
                border: none;
                background-image: none;
                padding: 0;
            }

            span{
                display: none;
            }
        }

        .wrapperProfileActive {
            width: 480px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .profile{
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
            }

            .selectAtive {
                color: #fff !important;
                font-size: 18px;
                font-weight: 500;
                width: 126px;
                border: none;
                margin-top: 17px;
                font-family: 'Quicksand', sans-serif;
            }
            .active{
                background-color: #00D36A;
            }

            .inactive{
                background-color: #FF5666 !important;
            }
        }

        .customGroups-list {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
                margin-bottom: 35px;

                .customGroups {
                    display: flex;
                    align-items: center;
                    background-color: transparent;
                    padding: 6px 12px;
                    border-radius: 999px;
                    border: 1px solid rgb(117, 117, 117);

                    span {
                        color: #403F4C;
                        font-size: 14px;

                    }
                }

                .remove-btn {
                    background: none;
                    border: none;
                    color: #c00;
                    margin-left: 8px;
                    font-size: 16px;
                    cursor: pointer;
                    transition: color 0.2s ease;
                }
            }

        input{
            width: 460px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            padding: 0 10px;
            margin-bottom: 15px;
            background-color: transparent;
            font-family: 'Quicksand', sans-serif;
            font-size: 14px;
            margin-top: 2px;
        }

        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #87868F;
        }

        .addInput{
            width: 128px;
            height: 32px;
            border-radius: 26px;
            margin: 0 24px;
            background: transparent;
            border: 1px solid #B2B2B7;
            color: #87868F;
            cursor: pointer;
            font-family: 'Work Sans', sans-serif;
        }

        input:invalid{
            width: 460px;
            height: 32px;
            border-radius: 26px;
            /* border: 1px solid red; */
            padding-left: 10px;
            margin-bottom: 15px;
        }

        .timezoneCard{
                div:nth-child(2){
                  width: 480px !important;

                  input{
                    width: 100% !important;
                  }
                  ul{
                    width: 480px !important;
                    li{
                      width: 100% !important;
                      button{
                        width: 100% !important;
                      }
                    }
                  }
                }
              }

        .inputs{
            display: flex;
            align-items: center;
            gap: 12px;



        .lineInputs{
            .gender{
                width: 243px;
            }

            .MuiInput-input-14 {
                width: 215px;
                border: none;
                height: 19px;
                margin: 0;
            }

            .MuiFormControl-root-30 {
                border: 1px solid;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
            }

            input{
                width: 220px;
            }

            select.userPhoneTypeId{
                width: 300px;
            }

        }

        p{
            font-size: 11px;
            color: #87868F;
            margin-top: 22px;
        }

    }


        .telephone{
            input{
                width: 220px;
            }

            button.addInput{
                margin: 20px 0 0 0;
                font-family: 'Work Sans', sans-serif;
            }
        }


        button.password{
          width: auto;
                padding: 8px 12px;
            border-radius: 26px;
            margin-left: 0;
            background: transparent;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            font-family: 'Quicksand', sans-serif;
            font-size: 14px;
            cursor: pointer;
            font-weight: 100;
            margin: 2px 0 44px 0;
        }

        .notification{
            display: flex;

            .switch__container{
                margin: 5px 0 0 23px;

                span{
                    margin-left: 47px;
                    font-size: 12px;
                    color: #707070;
                    font-family: 'Quicksand', sans-serif;
                }
            }

            span.delete{
                margin: 11px 0 0 0;
                width: 55px;
                font-weight: bold;
            }
        }

        .switchBox{
            display: flex;
        }

        .labelNotify{
            display: flex;
            flex-direction: column;
            width: auto;

            .doubleClick{
                color: #ccc !important;
            }
        }

        button.deleteLast{
            width: 83px;
            height: 22px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #FF5666;
            color: #FF5666;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 0;
            font-family: 'Quicksand', sans-serif;
        }

        .selects{
            display: flex;
            flex-direction: row;

        }

        .lineSelect{
            margin: 0 25px 0 0;

            p{
                font-size: 11px;
                margin-top: 22px;
                color: #403F4C;
            }
        }

        span.delete {
            color: red;
            font-size: 10px;
            font-weight: bold;
            margin-top: 30px;
            float: left;
        }


        button.jsx-4179805763 {
            width: 100%;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin: 0 0 1px 0 !important;
            background: #B2B2B7;
            border-radius: 0;
        }
        button.focus.jsx-4179805763  {
            background: #B2B2B7;
        }

        button.delete{
            width: 83px;
            height: 22px;
            border-radius: 26px;
            background: transparent;
            border: none;
            color: #FF5666;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 7px;

        }
    }

    .button{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-top: 15px;

        button.save{
          padding: 10px 20px;
            height: 38px;
            border-radius: 26px;
            background: #004FFF;
            border: 1px solid #004FFF;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            margin: 24px 0 30px 0;
            font-family: 'Work Sans', sans-serif;
        }

        button.back{
            width: 72px;
            height: 28px;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #787780;
            color: #787780;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 30px 15px 30px 0px;
            font-family: 'Quicksand', sans-serif;

            .fa{
                margin-right: 3px;
            }
        }
    }

    input.jsx-4179805763  {
        width: 480px;
        height: 32px;
        border-radius: 26px;
        border: 1px solid #B2B2B7;
        padding-left: 10px;
        margin-bottom: 15px;
        margin-top: 0;
    }

    button.jsx-4179805763  {
        margin: 0 0 1px 0 !important;
    }

    input[type='number'] {
        -moz-appearance:textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

`;
